var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pre',[_c('code',{domProps:{"innerHTML":_vm._s(_vm.code)}},[_vm._v("\n")]),_vm._v("\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }